<template>
  <svg
    width="15"
    height="15"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="margin-top: 1px;"
  >
    <path
      d="M17 8H4.83L10.42 2.41L9 1L1 9L9 17L10.41 15.59L4.83 10H5V8Z"
      :fill="fill"
      stroke=""
    />
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      required: true,
      type: String,
    },
  },
};
</script>
